import { BigNumber } from '@ethersproject/bignumber'
import React from 'react'
import styled from 'styled-components'
import { formatCurrency, Pair } from '../../model'
import { InputItem } from './InputItem'
import { CurrencySymbolImage } from './CurrencySymbolImage'
import { INTEGRAL_LP_SYMBOL } from '../../constants'
import { usePairSelectModal } from '../../providers'

interface Props {
  pair?: Pair
  label: string
  liquidityBalance: BigNumber
  value: string
  onValueChange: (value: string) => void
  onMax: () => void
  className?: string
}

export function LiquidityInputItem({ pair, label, liquidityBalance, value, onValueChange, onMax, className }: Props) {
  const balance = ((liquidityBalance && formatCurrency(18, liquidityBalance)) ?? '-').concat(' LP Tokens')
  const { togglePairSelectModal } = usePairSelectModal()

  return (
    <InputItem
      label={label}
      value={value}
      balance={balance}
      onValueChange={onValueChange}
      onMax={onMax}
      className={className}
    >
      <CurrencySymbolClickable onClick={togglePairSelectModal}>
        <CurrencySymbolImageStyled symbol={INTEGRAL_LP_SYMBOL} />
        {pair ? `${pair.getToken0Symbol()}-${pair.getToken1Symbol()}` : ''}
      </CurrencySymbolClickable>
    </InputItem>
  )
}

const CurrencySymbolImageStyled = styled(CurrencySymbolImage)`
  margin-right: 5px;
`
const CurrencySymbolClickable = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
